module.exports = __webpack_public_path__ + "dad782cbcad1190d8dbf943ccc657cc6.MP3";